/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_Kind_Gift_BannerInputs */

const vi_shop_home_kind_gift_banner = /** @type {(inputs: Shop_Home_Kind_Gift_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Banner quà biếu`)
};

/**

* @param {Shop_Home_Kind_Gift_BannerInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_kind_gift_banner = /** @type {((inputs?: Shop_Home_Kind_Gift_BannerInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Kind_Gift_BannerInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_kind_gift_banner(inputs)
});